import React from "react";
import Table from "../../Common/Table";
import TableFieldsIssuedList from "../../../constants/DriverAssets/TableFieldsIssuedList.json";
import { getReadableDateTime } from "../../../utils";

const IssuedList = (props) => {
  const { list } = props;

  const getFieldValue = (item, key) => {
    switch (key) {
      case "created_at":
        return getReadableDateTime(item[key]);
      default:
        return item[key] || item["asset"][key];
    }
  };

  return (
    <Table
      list={list}
      getFieldValue={getFieldValue}
      fields={TableFieldsIssuedList}
    />
  );
};

export default IssuedList;
